var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-end"},[_c('h3',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.title))]),_c('b-badge',{staticClass:"mb-1 ml-2",attrs:{"pill":"","variant":_vm.color}},[_vm._v(_vm._s(_vm.badge))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }